import React from "react";

const SaleRateRabiCropsSeeds = () => {
  return (
    <div className="container my-3">
      <div className="abouts">
        <h5>Sale Rate of Rabi Seeds - Crops</h5>
      </div>

      <div
        className="about-box p-4 rounded shadow-lg "
        style={{ textAlign: "justify" }}
      >
        <div className="row mb-1 justify-content-between">
          <div className="col-lg-12 mb-1">
            <h6>Our seed remains available easily at:</h6>

            <ol>
              <li>HSDC sale counters.</li>
              <li>
                Farmers&#39; Service Centres of Haryana Agro Industries
                Corporation.
              </li>
              <li>Mini Banks.</li>
              <li>Co-op. Societies of HAFED.</li>
              <li>Farmers&#39; Service Centres of HLRDC.</li>
            </ol>

            <div className="table-responsive">
              <table className="table table-striped table-bordered">
                <tbody>
                  <tr>
                    <th colspan="6" id="rabi" scope="col">
                      Sale Rate For Rabi 2023-24
                    </th>
                  </tr>
                  <tr>
                    <th rowspan="2">S.No.</th>
                    <th rowspan="2">Crop</th>
                    <th rowspan="2">Variety</th>
                    <th colspan="3" id="rabi1" scope="col">
                      Rates (Rupees per Quintal)
                    </th>
                  </tr>
                  <tr>
                    <th>Full Sale Rate</th>
                    <th>Subsidy</th>
                    <th>Subsidized sale rate to Farmer</th>
                  </tr>
                  <tr>
                    <td>1</td>
                    <td>Barseem</td>
                    <td>BL-10, BL-42</td>
                    <td>21000</td>
                    <td>0</td>
                    <td>
                      21000
                      <br />
                      (420/- Per 2Kg)
                    </td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>WHEAT</td>
                    <td>
                      (Varieties not older than 10 years from the date of
                      notification only)
                      <br />
                      HD-3298, WH-1124, WH-1105, HD-3086, WH-1270, PBW-725,
                      DBW-222, DBW-303, DBW-187, HD-3226, DBW-332, DBWH-221,
                      DBW-296 & DBW-327
                    </td>
                    <td>3725</td>
                    <td>1000</td>
                    <td>
                      2725
                      <br />
                      (1090 per bag of 40 kg)
                    </td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td>Gram</td>
                    <td>All Varieties</td>
                    <td>11000</td>
                    <td>5000</td>
                    <td>
                      6000
                      <br />
                      (960of 16 kg)
                    </td>
                  </tr>
                  <tr>
                    <td>4</td>
                    <td>Mustard</td>
                    <td>All Varieties</td>
                    <td>12000</td>
                    <td>4000</td>
                    <td>
                      8000
                      <br />
                      (160 of 2 kg)
                    </td>
                  </tr>
                  <tr>
                    <td>5</td>
                    <td>Barley</td>
                    <td>All Varieties</td>
                    <td>4000</td>
                    <td>1500</td>
                    <td>
                      2500
                      <br />
                      (750 of 30 kg)
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SaleRateRabiCropsSeeds;
